<template>
  <div class="relative">
    <div v-if="active" @click.self="advance" class="md-fixed top-0 right-0 bottom-0 left-0 bg-white z2">
      <ul ref="container" @click="advance" class="list-reset m0 p0 md-full-height overflow-auto">
        <li v-for="image in images" class="pb2 sm-pb3 md-pb0 flex justify-center items-center md-col-12 md-full-height">
          <responsive-image :image="image" class="zoom-image pointer-arrow-right"></responsive-image>
        </li>
      </ul>
      <div class="xs-hide sm-hide md-absolute sm-pl3 sm-pr2 sm-mt2 sm-pt2 top-0 left-0 line-height-1">
        <p @click="close" class="pointer">⟨ back</p>
      </div>
      <!-- <div v-if="post" class="xs-hide sm-hide md-absolute sm-px3 sm-my2 sm-py1 left-50 bottom-0 center h6 cursor auto">
        <h3 class="mt1 mb0">{{ title }}</h3>
        <p v-if="byline" class="m0">{{ byline }}</p>
      </div> -->
      <div v-if="post" class="xs-hide sm-hide md-absolute sm-px3 sm-my2 sm-py1 left-50 top-0 center h6 cursor-auto">
        <h3 class="mt1 mb0">{{ title }}</h3>
        <p v-if="byline" class="m0">{{ byline }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import debounce from 'debounce'
  import { mapMutations } from 'vuex'

  export default {
    name: 'gallery',
    data () {
      return {
        doc: document.documentElement,
        fixed: false,
        animate: false,
        idx: 0
      }
    },
    props: {
      images: {
        type: [Array, Boolean],
        required: true
      },
      post: Object
    },
    computed: {
      active () {
        return true
      },
      title () {
        if (!this.post) return

        return this.post.title.rendered
      },
      byline () {
        if (!this.post) return

        const { byline } = this.post.acf
        if (!byline || !byline.length) return false
        return byline
      },
      galleryLength () {
        return this.images && this.images.length
      }
    },
    methods: {
      init (route) {
        let { hash } = route
        if (!hash) {
          hash = '#0'
          // return this.close()
        }
        let idx = parseInt(hash.replace('#', ''))
        this.idx = idx

        if (!this.fixed) this.fixScroll()

        this.$nextTick(() => {
          this.scrollPos()
        })
      },
      scrollPos () {
        let current = this.$refs.container.getBoundingClientRect()
        let to = current.height * this.idx
        if (this.animate) {
          scrollTo(this.$refs.container, to, 333)
          this.animate = false
        } else {
          this.$refs.container.scrollTop = to
        }
      },
      advance () {
        if (window.innerWidth < 833) return
        let nextIdx = this.idx + 1
        if (nextIdx === this.galleryLength) {
          nextIdx = 0
        }
        this.animate = true
        this.$router.replace(`#${nextIdx}`)
      },
      fixScroll () {
        this.fixed = true
        this.doc.classList.add('md-overflow-hidden')
        this.$nextTick(() => {
          this.listen = debounce(this.bindScroll, 40)
          this.$refs.container.addEventListener('scroll', this.listen)
        })
      },
      releaseScroll () {
        this.fixed = false
        this.doc.classList.remove('md-overflow-hidden')
        // this.$refs.container.removeEventListener('scroll', this.listen)
      },
      close () {
        this.idx = 0
        this.releaseScroll()
        this.$router.go(-1)
      },

      bindScroll () {
        let current = this.$refs.container.getBoundingClientRect()
        let sp = this.$refs.container.scrollTop
        this.idx = Math.round(sp / current.height)
      },
      listen () {},

      ...mapMutations({
        'zoomState': 'TOGGLE_ZOOM_STATE'
      })
    },
    watch: {
      $route (newVal) {
        this.init(newVal)
      }
    },
    mounted () {
      this.init(this.$route)
    },
    destroyed () {
      this.releaseScroll()
    }
  }

  function scrollTo (element, to, duration) {
    let start = element.scrollTop
    let change = to - start
    let currentTime = 0
    let increment = 20

    var animateScroll = () => {
      currentTime += increment
      let val = easeInOutQuad(currentTime, start, change, duration)
      element.scrollTop = val
      if (currentTime < duration) {
        setTimeout(animateScroll, increment)
      }
    }
    animateScroll()
  }

  // t = current time
  // b = start value
  // c = change in value
  // d = duration
  function easeInOutQuad (t, b, c, d) {
    t /= d / 2
    if (t < 1) return c / 2 * t * t + b
    t--
    return -c / 2 * (t * (t - 2) - 1) + b
  }
</script>



// WEBPACK FOOTER //
// src/components/partials/Gallery.vue